export default "__VITE_ASSET__WGdueuRx__"